<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título y subtítulo -->
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #193D6E;">
            Historial de pagos realizados
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Aquí puedes consultar todos los pagos ya realizados a proveedores de flete.
          </div>
        </v-col>
      </v-row>

      <!-- Buscador y botón de descarga -->
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="2" lg="3" class="pl-0">
          <v-text-field
            v-model="search"
            min-width="288"
            max-width="288"
            label="Buscar"
            hide-details
            append-icon="mdi-magnify"
            outlined
            style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;"
          />
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn
            color="#0075B8"
            elevation="8"
            class="white--text"
            style="border-radius: 36px; border: 2px solid #0075BB; font-family: 'montserrat-semibold'; text-transform: none;"
            @click="descargarExcel"
          >
            <v-img
              class="mr-2"
              src="@/assets/icons/Vector.svg"
              style="width: 14px;"
            />
            Descargar
          </v-btn>
        </v-col>
      </v-row>

      <!-- Tabla desktop -->
      <v-data-table
        class="d-none d-sm-block"
        :headers="headers"
        :items="paymentsCedente"
        :search="search"
        hide-default-header
      >
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">Fecha</th>
              <th class="header__title center">Monto</th>
              <th class="header__title center">Método</th>
              <th class="header__title center">Referencia</th>
              <th class="header__title center">Nota</th>
              <th class="header__title right">Comprobante</th>
            </tr>
          </thead>
        </template>

        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in paymentsCedente" :key="item.id">
              <td class="table__item">{{ formatDate(item.fecha) }}</td>
              <td class="table__item">${{ formatMoney(item.amount) }} USD</td>
              <td class="table__item">{{ item.origin }}</td>
              <td class="table__item">{{ item.reference }}</td>
              <td class="table__item">{{ item.note }}</td>
              <td class="table__item">
                <v-btn icon color="black" @click="abrirDocumento(item)">
                  <v-icon>mdi-file-download-outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <!-- Tabla móvil -->
      <v-data-table class="d-sm-none d-block" :items="paymentsCedente" hide-default-header>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in paymentsCedente" :key="item.id" style="display: flex; flex-direction: column;">
              <td class="table__item__mobile"><strong>Fecha:</strong> {{ formatDate(item.fecha) }}</td>
              <td class="table__item__mobile"><strong>Monto:</strong>${{ formatMoney(item.amount) }} USD</td>
              <td class="table__item__mobile"><strong>Método:</strong>{{ item.origin }}</td>
              <td class="table__item__mobile"><strong>Referencia:</strong>{{ item.reference }}</td>
              <td class="table__item__mobile"><strong>Nota:</strong>{{ item.note }}</td>
              <td class="table__item__mobile">
                <v-btn icon small @click="abrirDocumento(item)">
                  <v-icon>mdi-file-download-outline</v-icon>
                </v-btn>
              </td>
              <v-divider></v-divider>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import moment from "moment"; 

export default {
  data() {
    return {
      search: "",
      headers: [],
      paymentsCedente: [],
    };
  },
  methods: {
    async getPayments() {
      try {
        this.isLoading = true;
        const response = await DB.get(`${URI}/api/v1/en/paymentsDebtor/client/`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.paymentsCedente = response.data.paymentsWithUrls;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    formatMoney(value) {
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    descargarExcel() {
      console.log("Descargando Excel...");
    },
    abrirDocumento(doc) {
      window.open(`${doc.file_url}`, '_blank');
    },
  },
  beforeMount() {
    this.getPayments();
  }
};
</script>

<style scoped>
.header__title {
  font-family: 'montserrat-semibold';
  font-size: 13px;
  padding: 12px;
}
.header__title.left {
  text-align: left;
}
.header__title.center {
  text-align: center;
}
.header__title.right {
  text-align: right;
}
</style>
